import { faro } from '@grafana/faro-web-sdk';

/**
 * Analytics Event Types
 */

type BookingFunnelEvent =
    | 'booking_view_item'
    | 'booking_initiate'
    | 'booking_step_personal'
    | 'booking_submit'
    | 'booking_success'
    | 'booking_error';

type ContactFormEvent =
    | 'contact_initiate'
    | 'contact_submit'
    | 'contact_success'
    | 'contact_error';

type PermitFormEvent =
    | 'permit_initiate'
    | 'permit_submit'
    | 'permit_success'
    | 'permit_error';

// Union of all event names
type AnalyticsEventName = BookingFunnelEvent | ContactFormEvent | PermitFormEvent;

/**
 * Analytics Attributes
 * Focus on low cardinality strings.
 */
interface AnalyticsAttributes {
    // Common
    source_page?: string;
    error_type?: string;

    // Vehicle / Booking
    vehicle_category?: string;
    vehicle_model?: string; // Only if not too high cardinality
    duration_tier?: '1-3d' | '4-7d' | '7-14d' | '14d+' | 'long_term';
    has_extras?: string; // 'true' | 'false'
    extras_chosen?: string; // Comma separated list of extra IDs
    payment_method?: string;

    // User Demographics (Low Cardinality)
    user_country?: string; // e.g. "FR", "DE", "UK"
    country_region?: string; // e.g. "EU", "NA", "AS"
    birth_year?: string;

    // Contact
    subject_category?: string;
    permit_type?: string;

    [key: string]: string | undefined;
}

/**
 * Helper to measure a value (metric)
 */
export function trackMeasurement(
    name: string,
    value: number,
    attributes?: AnalyticsAttributes
) {
    if (typeof window !== 'undefined' && faro.api) {
        faro.api.pushMeasurement({
            type: name,
            values: {
                [name]: value,
            },
            context: attributes as any,
        });
    }
}

/**
 * Helper to track a standard event log
 */
export function trackEvent(
    name: AnalyticsEventName,
    attributes?: AnalyticsAttributes
) {
    if (typeof window !== 'undefined' && faro.api) {
        faro.api.pushEvent(name, attributes as any);
    }
}

// Helper to determine duration tier
export function getDurationTier(days: number): AnalyticsAttributes['duration_tier'] {
    if (days <= 3) return '1-3d';
    if (days <= 7) return '4-7d';
    if (days <= 14) return '7-14d';
    if (days < 30) return '14d+';
    return 'long_term';
}
